import { render, staticRenderFns } from "./Temporal.vue?vue&type=template&id=2532d56e"
import script from "./Temporal.vue?vue&type=script&lang=js"
export * from "./Temporal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports